<form class="card mt-2">
  <div class="card-body">
    <div class="float-right">
      <a class="btn btn-secondary ml-2 " [routerLink]="'/benefitPlanEDI/tramissions'">Back</a>
    </div>
    <h2>Cobra Transmissions</h2>

    <div class="mb-3">

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Employee:</h5>
        </div>
        <div class="col-10">
          <div class="ml-2 w-100 mb-2">
            <p-autoComplete [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" [(ngModel)]="selectedUserEmployee"
                            [suggestions]="userEmployeeList" (completeMethod)="getStaffList($event)" field="name" dataKey="id"
                            [ngModelOptions]="{standalone: true}" [minLength]="1" [autoHighlight]="true"
                            (onSelect)="reloadListAfterStaffChange($event)" [forceSelection]="true"
                            (onClear)="reloadListAfterClear($event)"></p-autoComplete>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>File Name:</h5>
        </div>
        <div class="col-10">
          <input type="text" class="form-control ml-2 w-100 mb-2" [(ngModel)]="fileName" (blur)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}" />
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>File Type:</h5>
        </div>
        <div class="col-10">
          <p-select styleClass="app-select ml-2 w-100 mb-2" [options]="fileTypes" [(ngModel)]="fileType" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Date Generated:</h5>
        </div>
        <div class="col-10">
          <i *ngIf="!dateRangeList" class="material-icons rotate text-muted">loop</i>
          <p-select styleClass="app-select ml-2 w-100 mb-2" [options]="dateRangeList" [(ngModel)]="dateRange" optionLabel="text" (ngModelChange)="changedDateRange()" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
      </div>

      <div class="row" *ngIf="isCustomDateRange">
        <div class="col-2 d-flex align-items-center">
          <h5 style="padding-left:10px;">Start Date:</h5>
        </div>
        <div class="col-10">
          <input type="date" class="form-control ml-2 w-100 mb-2" [(ngModel)]="startDate" (blur)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}" />
        </div>
        <div class="col-2 d-flex align-items-center">
          <h5 style="padding-left:10px;">End Date:</h5>
        </div>
        <div class="col-10">
          <input type="date" class="form-control ml-2 w-100 mb-2" [(ngModel)]="endDate" (blur)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}" />
        </div>
      </div>

    </div>

    <i [hidden]="!loadingList" class="material-icons rotate text-muted">loop</i>
    <p-table #myTable [value]="list?.result" [responsive]="true" [paginator]="true" [rows]="20"
             [totalRecords]="list?.totalRecords" [lazy]="true" (onLazyLoad)="reloadFilter($event)"
             [tableStyle]="{ 'min-width': '60rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th [pSortableColumn]="'FileName'">File Name <p-sortIcon [field]="'FileName'"></p-sortIcon></th>
          <th [pSortableColumn]="'FileType'">File Type <p-sortIcon [field]="'FileType'"></p-sortIcon></th>
          <th [pSortableColumn]="'DateGenerated'">Date Generated <p-sortIcon [field]="'DateGenerated'"></p-sortIcon></th>
          <th>Employees</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-list>
        <tr (click)="selectItem(list)" title="View raw data file" class="clickable-row" [class.selected] ="selectedItem == list">
          <td>
            <span class="ui-column-title">File Name</span>
            {{list.fileName}}
          </td>
          <td>
            <span class="ui-column-title">File Type</span>
            {{list.fileType}}
          </td>
          <td>
            <span class="ui-column-title">Date Generated</span>
            {{list.dateGenerated | date: 'MM/dd/yyyy'}}
          </td>
          <td>
            <span class="ui-column-title">Employees</span>
            <div *ngFor="let item of list.employees; let last = last">
              {{ item }}<br *ngIf="!last" />
            </div>
          </td>
        </tr>
        <tr *ngIf="selectedItem == list">
          <td colspan="100">
            <div class="cobra-file-data">
              {{formatFileData(list.fileData)}}
              <!-- Close "X" in top-right -->
              <span class="cobra-close-icon" (click)="clearSelected()">×</span>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft" let-state>
        Showing {{ state.first + 1 }} - {{ (state.first + state.rows) > state.totalRecords ? state.totalRecords : (state.first + state.rows) }} of {{ state.totalRecords }} entries
      </ng-template>
      <ng-template pTemplate="paginatorright">
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <span style="color: #495057; font-size: 14px; white-space: nowrap;">Rows per page:</span>
          <p-dropdown [options]="dropdownOptions()"
                      optionLabel="label"
                      optionValue="value"
                      [ngModel]="myTable.rows"
                      [ngModelOptions]="{standalone: true}"
                      (onChange)="myTable.rows = $event.value; myTable.reset()">
          </p-dropdown>
        </div>
      </ng-template>
    </p-table>
  </div>
</form>
